import { render } from "./EmergencyView.vue?vue&type=template&id=101146d4&scoped=true"
import script from "./EmergencyView.vue?vue&type=script&lang=js"
export * from "./EmergencyView.vue?vue&type=script&lang=js"

import "./EmergencyView.vue?vue&type=style&index=0&id=101146d4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101146d4"]])

export default __exports__